import html from "./PatientEnteredNotes.html"
import "./PatientEnteredNotes.css"
import autosize from "autosize"

var module = angular.module("ResearchKitApplicationModule");

module.component('patientEnteredNotesDashboardComponent', {
	template: html,
	bindings: {
		"model": "<"
	},
	controller: 'patientEnteredNotesController',
	controllerAs: 'vm'
});

module.controller("patientEnteredNotesController", ["$http", "$element", "$timeout", "ceUrl",
	function ($http, $element, $timeout, ceUrl) {
		var vm = this;

		vm.saveNotes = function () {
			$http.post(ceUrl.make("api/patiententerednotes"), vm.model);
		};

		vm.$onInit = function () {
			$timeout(function () {
				autosize($element.find("textarea")[0]);
			}, 0, false);
		};
	}
]);
